import type { HighlightVideo } from '@/domain/player'
import styles from './VideoSection.module.css'

interface Props {
  videos: HighlightVideo[]
  playerName: string
}

export function VideoSection({ videos, playerName }: Props) {
  return (
    <section className={styles.container} aria-label={`${playerName}のハイライト動画`}>
      <h3 className={styles.heading}>ハイライト動画</h3>

      {videos.length === 0 ? (
        <p className={styles.empty}>動画が見つかりませんでした</p>
      ) : (
        <ul className={styles.videoList} role="list">
          {videos.map((video) => (
            <li key={video.videoId} className={styles.videoCard}>
              {video.embeddable ? (
                <div className={styles.embedWrapper}>
                  <iframe
                    className={styles.iframe}
                    src={`https://www.youtube.com/embed/${video.videoId}`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              ) : (
                <div className={styles.videoMeta}>
                  <p className={styles.videoTitle}>{video.title}</p>
                  <a
                    href={`https://www.youtube.com/watch?v=${video.videoId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.externalLink}
                    aria-label={`${video.title} (YouTubeで開く)`}
                  >
                    YouTubeで見る ↗
                  </a>
                </div>
              )}
              {video.embeddable && (
                <div className={styles.videoMeta}>
                  <p className={styles.videoTitle}>{video.title}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
